<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属经销商" name="company_name" readonly @click="$refs.stationedSelector.open(2)"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="select" label="结算状态" name="state" :options="state" ></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="支付时间"
					name="payment_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="订单号"
					name="order_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="经销商名称"
					name="stationed_name"
					width="160"
				></c-table-column>

				<c-table-column
					label="订单类型"
					name="order_type"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.order_type==1" style="color:#888888">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==2" style="color:#ff00ff">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==3" style="color:#000000">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==4" style="color:#ff0000">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==5" style="color:#707070">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==6" style="color:#aaaa00">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==7" style="color:#0000ff">{{orderTypeName[data.order_type]}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="商品数量"
					name="product_count"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="商品金额"
					name="product_money"
					width="120"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.product_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="订单运费"
					name="logistics_money"
					width="120"
				>
					<template v-slot="row">
						{{'¥'+parseFloat(row.data.logistics_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="其他费用"
					name="other_fee"
					width="120"
				>
					<template v-slot="row">
						<span v-if="row.data.other_fee && row.data.other_fee > 0" style="color:#ff00ff">
							{{'¥'+parseFloat(row.data.other_fee).toFixed(2)}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="结算状态"
					name="state"
					width="75"
				>
					<template v-slot="{data}">
						<span v-if="data.state==1" style="color:darkgray">{{transStateName[data.state]}}</span>
						<span v-if="data.state==2" style="color:brown">{{transStateName[data.state]}}</span>
						<span v-if="data.state==3" style="color:darkgreen">{{transStateName[data.state]}}</span>
						<span v-if="data.state==4" style="color:red">{{transStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/settlement/detail/${data.order_number}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	export default {
		name: 'm_seller_order_settlement',
		
		components: {
			stationedSelector
		},
		
		data() {
			return {
				transStateName: {
            4: '取消结算',
            1: '待结算',
            2: '部分结算',
            3: '全部结算'
				},
				state: [
            {name: '待结算',value: 1},
            {name: '部分结算',value: 2},
            {name: '全部结算',value: 3},
            {name: '取消结算',value: 4}
				],
				orderTypeName: {
            1: '普通',
            2: '积分',
            3: '赠品',
            4: '砍价',
            5: '全款预售',
            6: '定金预定',
            7: '定制',
            8: '拼团',
            9: '云仓提货',
            10: '送礼',
            11: '抽奖'
				}
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 2;
				this.$refs.table.load({
					url: '/order/settlement/list',
					data
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>